/*
 * @Author: csu chen.su@murata.com
 * @Date: 2022-06-22 15:36:49
 * @LastEditors: csu chen.su@murata.com
 * @LastEditTime: 2024-01-30 17:55:58
 * @FilePath: \frontend\src\store\modules\user.js
 */
import { resetRouter } from '@/router';

const getDefaultState = () => {
  return {
    user_name: '',
    user_id: '',
    token: null,
    mode: 0,
    tenantId: '',
  };
};

const resetState = () => {
  return {
    user_name: '',
    user_id: '',
    token: null,
  };
};

const state = getDefaultState();

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, resetState());
  },
  SET_USERNAME: (state, user_name) => {
    state.user_name = user_name;
  },
  SET_USERID: (state, user_id) => {
    state.user_id = user_id;
  },
  SET_USERCONFIG: (state, userConfig) => {
    state.userConfig = userConfig;
  },
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_MODE: (state, mode) => {
    state.mode = mode;
  },
  SET_TENANT_ID: (state, tenantId) => {
    state.tenantId = tenantId;
  },
};

const actions = {
  // get user info
  setUsername({ commit, state }, user_name) {
    commit('SET_USERNAME', user_name);
  },

  setUserId({ commit, state }, user_id) {
    commit('SET_USERID', user_id);
  },

  setMode({ commit, state }, mode) {
    commit('SET_MODE', mode);
  },

  setToken({ commit, state }, token) {
    commit('SET_TOKEN', token);
  },

  setTenantId({ commit, state }, tenantId) {
    commit('SET_TENANT_ID', tenantId);
  },

  resetUser({ commit, dispatch }) {
    resetRouter();
    dispatch('service/resetService', null, { root: true });
    commit('RESET_STATE');
  },

  // user logout
  logout({ commit, dispatch }) {
    return new Promise((resolve) => {
      resetRouter();
      dispatch('service/resetService', null, { root: true });
      commit('RESET_STATE');
      resolve();
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
